export const AccordionController = () => {
  $('.accordion').each((i, acc) => {
    accordionPanel(acc);
  })
}


const accordionPanel = (acc) => {
  const $accordion = $(acc);
  const $buttons = $accordion.find('.accordion__button');

  $buttons.each((i, btn) => {
    const $btn = $(btn);
    const targetID = $btn.attr('aria-controls');

    $btn.on('click', (e) => {
      let expanded = $btn.attr('aria-expanded') === 'true' || false;
      $btn.attr('aria-expanded', !expanded);
      $('#' + targetID).prop('hidden', expanded);
      $btn.closest('.accordion__section').attr('data-expanded', !expanded);
    })
  });
}



// WEBPACK FOOTER //
// ./src/js/controllers/AccordionController.js